<template>
        <table  class='borderedtable'>
            <tr class="bigtitle">
                  <!--<th>guest</th><th>checkin</th><th>時間</th><th>入金</th><th>項目</th><th>方法</th> <th>Memo</th> <th>Staff</th>-->
                  <th>入金時間</th><th>入金</th><th>方法</th><th>guest</th><th>check-in</th><th>memo</th><th>staff</th>
            </tr>
            <tr v-for="(value, index) in payentries" :key="index">
                  <td :class="itemclass">{{ DateUtils.displayHourMinute(value.mydate) }}</td>

                  <td v-if="userrole=='manager1'" :class="{ 'strikeout': userrole=='manager1' && value.t_field=='1' }">{{ FormatUtils.display_money(value.amount) }}</td>
                  <td v-else :class="itemclass" class="money">{{ FormatUtils.display_money(value.amount) }}</td>

                  <td :class="itemclass">{{ (value.minor) }}</td>

                  <td v-if="userrole=='manager1'" :class="{ 'strikeout': userrole=='manager1' && value.t_field=='1' }">{{ value.guest }}</td>
                  <td v-else :class="itemclass">{{ value.guest }}</td>

                  <td :class="itemclass">{{ DateUtils.display_date(value.indate, 'y_m_d') }}</td>
                  <!--<td :class="itemclass">{{ (value.major) }}</td>-->
                  <td :class="itemclass">{{ (value.memo) }}</td>
                  <td :class="itemclass">{{ (value.staff) }}</td>
            </tr>
        </table>
</template>
<script>
import {FormatUtils} from  '@/classes/Utils/FormatUtils.js';
import {DateUtils} from  '@/classes/Utils/DateUtils.js';

// 2025 09 17 t_field
import { userinfo } from '@/classes/UserInfo.js';
import { computed,  } from 'vue';

export default {

    props: [ 'payentries', ],    // data received from the parent component (myaccounting)
    name: 'DayAccount',
    setup() {

      const userrole = computed(() => userinfo.get_userrole() );

      return { FormatUtils, DateUtils, userrole }

    },
}
</script>


<style scoped>
.strikeout {
  /*text-decoration: line-through; */
  text-decoration: line-through;
  text-decoration-style: double;
  color: red; /* Optional: grey out completed tasks */
}
  .pink {
    background-color: rgb(209, 195, 189);
  }
  .green {
    background-color: rgb(157, 212, 210);
  }
.borderedtable {
    border: 1px solid black;
    border-collapse: collapse;
    width: 100%;
}
.border {
    border: 1px solid black;
    border-collapse: collapse;
}

     
      .black {
        color: black;
      }

</style>

